import styles from './PerformanceSummary.module.scss';
import { useTranslation } from 'react-i18next';
import DashboardSection from '../dashboard-section/DashboardSection';
import AreaChartScenario from '@customer/components/charts/area-chart-scenario/AreaChartScenario';
import { SelectionTimeRange } from '@customer/store/slices/globalSlice';
import { useCallback } from 'react';
import { ChartColorScheme } from '@customer/components/charts/config';
import { StatsScenario } from '@customer/store/apis/scenariosApi';
import SummaryChartCard from '../summary-chart-card/SummaryChartCard';
import { VILevel } from '@customer/store/apis/interactionsApi';

const TIME_RANGE = SelectionTimeRange.Days7;

const onlyShowAlarmInteractions = (label: string): boolean => label !== VILevel.Alarm;

export function PerformanceSummary() {
  const { t } = useTranslation();

  const getVIDataSetLabel = useCallback((label: string) => t(`vi.level.${label}`), [t]);

  const getGIDataSetLabel = useCallback(() => t('gi.counts'), [t]);

  return (
    <DashboardSection title={t('CasPerformanceSummary')} subtitle={t('LastDays', { val: 7 })}>
      <div className={styles.cards}>
        <SummaryChartCard title={t('VehicleInteractions')} to="/performance/vehicle-interactions">
          <AreaChartScenario
            scenario={StatsScenario.VehicleInteractionsByTimeRange}
            colorScheme={ChartColorScheme.RedOrangeYellow}
            getDataSetLabel={getVIDataSetLabel}
            tooltipTransKey="InteractionsWithCount"
            includeTimeRange
            timeRange={TIME_RANGE}
            hideCondition={onlyShowAlarmInteractions}
          />
        </SummaryChartCard>
        <SummaryChartCard title={t('GeofenceInteractions')} to="/performance/geofence-interactions">
          <AreaChartScenario
            scenario={StatsScenario.GeofenceInteractionsByTimeRange}
            colorScheme={ChartColorScheme.Blue}
            getDataSetLabel={getGIDataSetLabel}
            tooltipTransKey="InteractionsWithCount"
            includeTimeRange
            timeRange={TIME_RANGE}
          />
        </SummaryChartCard>
      </div>
    </DashboardSection>
  );
}

export default PerformanceSummary;
